// extracted by mini-css-extract-plugin
export default {"background":"InfoModal_background__Vl2iu","modal":"InfoModal_modal__Dcvru","btn_main":"InfoModal_btn_main__SM-+b"};